import { DialogHeader } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { useTranslations } from 'next-intl'
import { ErrorMessage } from './error-message'
import { PrimaryButton } from './primary-button'
import { StepHeader } from './step-header'
import { StepTitleSection } from './step-title-section'

type OtpStepProps = {
	email: string
	otpCode: string
	setOtpCode: (value: string) => void
	onSubmit: () => void
	onBack: () => void
	onResend: () => void
	onAutoSubmit: (code: string) => void
	isLoading: boolean
	error: string | null
}

export function OtpStep({
	email,
	otpCode,
	setOtpCode,
	onSubmit,
	onBack,
	onResend,
	onAutoSubmit,
	isLoading,
	error,
}: OtpStepProps) {
	const t = useTranslations('auth')

	return (
		<>
			<DialogHeader>
				<div className="flex flex-col gap-[32px]">
					<StepHeader showBack onBack={onBack} />
					<StepTitleSection
						title={t('enterVerificationCode')}
						description={t('codeSentTo', { email })}
					/>
				</div>
			</DialogHeader>

			<div className="flex flex-col gap-[24px]">
				<Input
					type="text"
					inputMode="numeric"
					pattern="[0-9]*"
					maxLength={6}
					placeholder="- - - - - -"
					value={otpCode}
					onChange={e => {
						const value = e.target.value.replace(/\D/g, '')
						setOtpCode(value)
						if (value.length === 6) {
							setTimeout(() => onAutoSubmit(value), 100)
						}
					}}
					className="h-[48px] rounded-[12px] border border-brand-gray bg-brand-dark py-[12px] text-center font-normal text-[24px] text-white leading-[100%] tracking-[0.5em] placeholder:text-brand-gray-secondary placeholder:tracking-[0.5em]"
					autoFocus
					onKeyDown={e => e.key === 'Enter' && onSubmit()}
				/>

				<ErrorMessage error={error} />

				<PrimaryButton
					onClick={onSubmit}
					disabled={isLoading || otpCode.length !== 6}
					isLoading={isLoading}
				>
					{t('verify')}
				</PrimaryButton>

				<p className="text-center font-normal text-[16px] text-brand-gray-secondary leading-[100%]">
					{t('didntReceiveCode')}{' '}
					<button
						type="button"
						onClick={onResend}
						className="font-semibold text-white transition-colors hover:text-brand-blue"
						disabled={isLoading}
					>
						{t('resend')}
					</button>
				</p>
			</div>
		</>
	)
}
